import { GET_LEADS_CAP_VERSIONS_REQUEST, GET_LEADS_CAP_VERSIONS_REQUEST_SUCCESS, GET_LEADS_CAP_VERSIONS_REQUEST_FAILURE } from '../../constants/cap.constants';

export const getLeadsCapVersionsRequest = model_id => ({ type: GET_LEADS_CAP_VERSIONS_REQUEST, model_id });
export const getLeadsCapVersionsRequestSuccess = payload => ({ type: GET_LEADS_CAP_VERSIONS_REQUEST_SUCCESS, payload });
export const getLeadsCapVersionsRequestFailure = error => ({ type: GET_LEADS_CAP_VERSIONS_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/cap_actions/get_cap_versions.actions.js